import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Checkbox, Grid, Select} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import CommercialTable from '../../../../common/components/commercialTable/commercialTable';
import {DefaultColumnFilter} from '../../../../manageOrders/components/internalCommons/TableFilters';
import WtsPositionsModal from './positionsModal';
import WtsPositionsTechDetailsModal from './positionsTechDetailsModal';

const {
  getWtsPositions,
  updateWtsPositionStatus,
} = Actions;

function WtsPositions({activeTab}) {
  const wtsPositions = useSelector((state) => state.wtsPositions.positions);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);

  const dispatch = useDispatch();

  useEffect(() => {
    if (areaSelected && activeTab === 3) {
      dispatch(getWtsPositions(areaSelected.id));
    }
  }, [areaSelected, activeTab]);

  const updateStatus = (e, checkedValue, item) => {
    e.preventDefault();
    const data = {
      'code': item.code,
      'status': checkedValue ? 'A' : 'I',
    };
    dispatch(updateWtsPositionStatus(areaSelected.id, {'data': data}));
  };

  const SelectColumnFilter = ({
    'column': {filterValue, setFilter},
  }) => {
    const options = [
      {'key': 'all', 'value': '', 'text': 'TODOS'},
      {'key': 'active', 'value': 'A', 'text': 'ACTIVO'},
      {'key': 'inactive', 'value': 'I', 'text': 'INACTIVO'},
    ];

    return (
      <Select
        compact
        placeholder="TODOS"
        value={filterValue || ''}
        options={options}
        style={{'minWidth': '120px', 'width': '100%'}}
        onChange={(e, {value}) => {
          setFilter(value || '');
          if (!value && areaSelected) {
            dispatch(getWtsPositions(areaSelected.id));
          }
        }}
      />
    );
  };

  const columns = [
    {
      'Header': () => <span className="header-title">CARGO</span>,
      'accessor': 'code',
    },
    {
      'Header': () => <span className="header-title">ESTADO</span>,
      'accessor': 'status',
      'Filter': SelectColumnFilter,
      'filter': (rows, id, filterValue) => {
        if (filterValue === '' || !filterValue) {
          return rows;
        }
        return rows.filter((row) => row.values[id] === filterValue);
      },
      'Cell': (item) => {
        return (
          <Checkbox
            toggle
            checked={item.value === 'A'}
            className='green'
            onChange={(e, input) => updateStatus(e, input.checked, item.row.original)}
          />
        );
      },
    },
    {
      'Header': () => <span className="header-title">ACCIONES</span>,
      'id': 'pos_actions',
      'width': 1,
      'Cell': (item) => {
        return (
          <div className='flex center end'>
            <WtsPositionsModal mode='edit' positionToEdit={item.row.original} />
          </div>
        );
      },
    },
  ];

  return (
    <Grid padded>
      <Grid.Row style={{'padding': 0}}>
        <Grid.Column textAlign='left' width={14}>
          <WtsPositionsModal mode='new' />
        </Grid.Column>
        <Grid.Column width={2} textAlign='right'>
          <WtsPositionsTechDetailsModal />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8}>
          <CommercialTable
            columns={columns}
            data={wtsPositions}
            defaultColumnFilter={DefaultColumnFilter}
            defaultPagination={10}
            initialState={{
              'filters': [
                {
                  'id': 'status',
                  'value': '',
                },
              ],
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default WtsPositions;
